import React from 'react';

const ArrowDownIcon = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="15" height="9" viewBox="0 0 10 6">
      <g fill="none" fillRule="evenodd">
        <path d="M-3-5h16v16H-3z" />
        <path fill="#ACB4BB" d="M0 0h1.5L5 4l3.5-4H10L5 6z" />
        <path fill="#ACB4BB" d="M0 0h1.5L5 4l3.5-4H10L5 6z" />
      </g>
    </svg>
  );
};

export default ArrowDownIcon;
